export default "__VITE_ASSET___p8Gjrvw__"